var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgLiveActive = function SvgLiveActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 29.323 28.105"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "LiveActive_svg__a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#126bd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#439aff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    d: "M24.766 18.311v4.435a2.269 2.269 0 01-2.326 2.2c-2.208-.048-5.673 0-5.673 0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 20,
    fill: "url(#LiveActive_svg__a)",
    rx: 1.5,
    transform: "translate(3 7.105)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    d: "M2.157 6.972h23.009a2.157 2.157 0 012.157 2.157v15.818a2.157 2.157 0 01-2.157 2.157H2.157A2.157 2.157 0 010 24.947V9.129a2.157 2.157 0 012.157-2.157z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.709 19.454H8.84v1.18H4.234v-7.157h1.475zm5.549 1.185H9.784v-7.162h1.475zm4.016-1.774l1.622-5.382h1.642l-2.493 7.151h-1.538l-2.482-7.157h1.637zm8.248-1.327H20.69v1.916h3.323v1.18h-4.8v-7.157H24v1.194h-3.31v1.706h2.831z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.075.2a.795.795 0 00-1.056 1.189zm6.624 6.951l-.528.594.528.469.528-.469zm7.68-5.763A.795.795 0 0019.323.2zm-15.36 0l7.152 6.357 1.056-1.188L6.075.2zm8.208 6.357l7.152-6.357L19.323.2l-7.152 6.358z"
  }))));
};
export default SvgLiveActive;